import { api } from './client';
import type { NotificationItem, PaginatedResponse } from '@/types/domain';

export async function fetchNotifications(
  unreadOnly = false,
  cursor: string | null = null,
): Promise<PaginatedResponse<NotificationItem>> {
  return api.get('/notifications/', {
    query: { unread_only: unreadOnly || undefined, cursor: cursor ?? undefined },
  });
}

export async function markNotificationRead(id: number): Promise<void> {
  await api.post(`/notifications/${id}/read/`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.post('/notifications/read-all/');
}
